import { Box, Button, Center, List, ListItem } from "@chakra-ui/react"
import { signOut } from "firebase/auth"
import Link from "next/link"
import { useRouter } from "next/router"
import { useState } from "react"
import { BsPersonCircle } from "react-icons/bs"
import { REGISTER_ROUTE_SERVICE } from "../../../entities/ShopAuthority"
import { auth } from "../../../firebase/Firebase"
import { createNotification } from "../../../lib/notification"
import { AccountIconLink, HomeIconLink, SettingsIconLink, TicketIconLink } from "../../atoms/link/IconLinks"
import useAuthContext from "../../context/AuthContext"

const GlobalLeftBar = ({ className, active } : { className?: string, active: string }) => {

  const [isOpen, setIsOpen] = useState(false)
  const { currentAuthority } = useAuthContext()

  return (<div className={`h-screen box-border pt-12 bg-white relative overscroll-contain flex flex-shrink-0 justify-between flex-col w-20 z-30 shadow-xl ${className}`}>
    <ul>
      <li className={`py-3 w-full align-middle text-center mb-5 ${ active == 'home' ? 'bg-gray-200' : ''}`}>
        <HomeIconLink />
      </li>
      <li className={`py-3 w-full align-middle text-center mb-5 ${ active == 'ticket' ? 'bg-gray-200' : ''}`}>
        <TicketIconLink />
      </li>
      { currentAuthority?.service == REGISTER_ROUTE_SERVICE.Web &&
      <li className={`py-3 w-full align-middle text-center mb-5 ${ active == 'account' ? 'bg-gray-200' : ''}`}>
        <AccountIconLink />
      </li>}
      <li className={`py-3 w-full align-middle text-center mb-5 ${ active == 'setting' ? 'bg-gray-200' : ''}`}>
        <SettingsIconLink />
      </li>
    </ul>
    <div className={`py-3 w-full align-middle text-center mb-5`} onClick={() => setIsOpen(!isOpen)}>
      <Center>
        <BsPersonCircle
          fontSize="inherit"
          style={{ fontSize: "3.5rem", color: "#707C97" }}
        />
      </Center>
    </div>
    <Tooltip isOpen={isOpen} />
  </div>)
}

const Tooltip = ({isOpen}) => {

  const router = useRouter()
  const {currentAgent} = useAuthContext()

  return (<Box
    w={80}
    mb={10}
    border="1px"
    borderColor={'gray.100'}
    bgColor="white"
    boxShadow={'md'}
    display={`${isOpen ? 'block' : 'none'}`}
    position="absolute"
    bottom={10}
    left={'120%'}
    borderRadius={"lg"}
  >
    <List
      fontSize={'xl'}
    >
      <ListItem
        p={3}
        borderBottom="1px"
      >
        {currentAgent?.name || currentAgent?.email}
      </ListItem>
      <ListItem
        borderBottom="1px"
      >
        <Link className="w-full h-full p-3 inline-block hover:bg-gray-100" href='/auth/selectShop'>
          ショップ変更
        </Link>
      </ListItem>
      <ListItem>
        <Button
          bgColor={'white'}
          w='full'
          onClick={() => {
            signOut(auth).then(() => {
              localStorage.clear()
              router.push('/auth/login')
            }).catch((error) => {
              createNotification('error', 'サインアウトに失敗しました')
            })
          }
        }>ログアウト</Button>
      </ListItem>
    </List>
  </Box>)
}

export default GlobalLeftBar;